<template>
  <v-select
    v-model="office_group"
    item-text="name"
    item-value="id"
    :items="office_groups"
    label="Office Group"
    outlined
    @input="change_role()"
  >
  </v-select>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    office_group: "Not Assigned",
  }),
  computed: {
    ...mapState({
      items: (state) => state.office_groups.office_groups,
    }),
    office_groups() {
      return this.items.map((x) => {
        return {name:x.name,id:x.id}
      });
    },
  },
  methods: {
    change_role() {
      console.log(this.office_group);
      this.$store.dispatch("file_imports/set_office_group", this.office_group);
      this.$emit("input", this.office_group);
    },
  },
  mounted: function () {
    this.office_group = "Not Assigned";
  },
};
</script>
